import { FilterOption } from '../interfaces/FilterOption';
import { Language } from '../interfaces/Language';
import { Site } from '../interfaces/Site';

class MapToFilterOptions {
  public static mapToFilterOptions(data: Site[] | Language[]): FilterOption[] {
    return data.map((element) => ({
      id: element.id,
      name: element.attributes.name,
    }));
  }
}

export default MapToFilterOptions;
